export class CatalogItem {
  id: string | undefined;
  catalogId: string | undefined;
  name: string | undefined;
  description: string | undefined;
  price: number | undefined;
  isDiscount: boolean | false;
  currencyCode: string | undefined;
  createdAt: Date | undefined;
  updatedAt: Date | undefined;

  constructor(data: Partial<CatalogItem>) {
    this.id = data.id;
    this.catalogId = data.catalogId;
    this.name = data.name;
    this.description = data.description;
    this.price = data.price;
    this.isDiscount = data.isDiscount ?? false;
    this.currencyCode = data.currencyCode;
    this.createdAt = data.createdAt;
    this.updatedAt = data.updatedAt;
  }

  clone(): CatalogItem {
    return new CatalogItem({ ...this });
  }
  static createEmpty(): CatalogItem {
    return new CatalogItem({
      id: '',
      catalogId: '',
      name: '',
      description: '',
      price: 0.0,
      isDiscount: false,
      currencyCode: '',
      createdAt: new Date(),
      updatedAt: new Date(),
    });
  }
}
